/* BVH — inline blog search.
 * Filters already-rendered article cards on the page instead of
 * navigating to /search. Falls back to the native search page if JS
 * is unavailable, because the <form> action is left intact.
 * Scoped per section so multiple blog sections cannot collide.
 */
(function () {
  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function init(form) {
    if (form.dataset.blogSearchReady === 'true') return;
    form.dataset.blogSearchReady = 'true';

    var scope = form.closest('[data-blog-search-scope]') || document;
    var input = form.querySelector('[data-blog-search-input]');
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-search-text]'));
    var empty = scope.querySelector('[data-blog-search-empty]');
    var clears = Array.prototype.slice.call(scope.querySelectorAll('[data-blog-search-clear]'));
    var countEl = scope.querySelector('[data-blog-search-count]');

    if (!input || items.length === 0) return;

    function apply() {
      var query = normalize(input.value);
      var tokens = query ? query.split(' ').filter(function (t) { return t.length > 1; }) : [];
      var shown = 0;

      items.forEach(function (el) {
        if (tokens.length === 0) {
          el.hidden = false;
          shown += 1;
          return;
        }
        var haystack = el.getAttribute('data-search-text') || '';
        var hit = tokens.some(function (t) { return haystack.indexOf(t) !== -1; });
        el.hidden = !hit;
        if (hit) shown += 1;
      });

      if (empty) empty.hidden = !(tokens.length > 0 && shown === 0);
      clears.forEach(function (btn) { btn.hidden = tokens.length === 0; });

      if (countEl) {
        if (tokens.length === 0) {
          countEl.textContent = '';
        } else {
          countEl.textContent = shown + (shown === 1 ? ' recipe' : ' recipes') + ' matching “' + input.value.trim() + '”';
        }
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      apply();
    });

    var timer = null;
    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(apply, 120);
    });

    input.addEventListener('search', apply);

    clears.forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = '';
        apply();
        input.focus();
      });
    });

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-blog-search-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
